import styled from 'styled-components';

export const OptionGroupWrapper = styled.div`
  line-height: ${props => props.theme.lineHeight};
  padding-bottom: ${props => props.theme.padding};
  text-align: ${props => props.theme.basketItem.optionsGroup.textAlign};
`;

export const OptionGroupStyled = styled.div`
  display: flex;
  flex-flow: row wrap;
  font-size: ${props => props.theme.fontSize};
  color: ${props => props.theme.quinaryColor};
  background-color: ${props => props.theme.basketItem.optionsGroup.backgroundColor};
  box-shadow: ${p => p.theme.basketItem.optionsGroup.boxShadow};
  padding: 0.6rem;
  border-radius: 7px;
`;

export const OptionGroupName = styled.span`
  font-size: ${props => props.theme.basketItem.optionsGroup.fontSize};
  color: ${props => props.theme.basketItem.optionsGroup.color};
  line-height: ${props => props.theme.basketItem.optionsGroup.lineHeight};
`;

export const OptionGroupInfo = styled.span`
  padding: ${props => props.theme.padding};
  font-size: ${props => props.theme.basketItem.optionsGroupInfo.fontSize};
  color: ${props => props.theme.basketItem.optionsGroupInfo.color};
`;



// WEBPACK FOOTER //
// ./components/Meal/OptionGroups.style.js